































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import ModalImage from '@/app/ui/components/ImageGallery/index.vue'
import ImageSelect from '@/app/ui/components/SelectImage/index.vue'
import { TrainingCategoryDataModule } from '@/app/store/modules/trainingCategory'

import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import {
  required,
  minLength,
  maxLength,
  not,
  sameAs,
} from 'vuelidate/lib/validators'
import { defaultImage } from '@/utils/default'
@Component({
  components: {
    'modal-image': ModalImage,
    'image-select': ImageSelect,
  },
})
export default class extends Vue {
  @Prop({}) public idModal
  @Prop({}) public imageDataCategory
  @Prop({}) public isLoading
  public $v: Vuelidate

  @Validate({
    required,
    minLength: minLength(4),
    maxLength: maxLength(255),
  })
  public name = ''
  public status = true
  public carType = 'Passenger Car'
  public optionscarType = [
    // di map dari master car
    { value: 'Passenger Car', text: 'Passenger Car' },
    { value: 'Light Commercial Vehicle', text: 'Light Commercial Vehicle' },
  ]
  public optionsStatus = [
    { value: true, text: 'Active' },
    { value: false, text: 'Inactive' },
  ]

  public resetAdd() {
    this.$v.name.$reset()
    this.name = ''
    this.status = true
    this.carType = 'Passenger Car'
    this.stateCarType = false
    this.stateStatus = false
    this.stateCoverImage = false
    this.stateThumbnailImage = false
    this.stateLogoImage = false
    this.imageCoverId = {
      id: null,
      link: defaultImage,
    }
    this.imageThumbnailId = {
      id: null,
      link: defaultImage,
    }
    this.imageLogoId = {
      id: null,
      link: defaultImage,
    }
  }
  public onClearSelected() {
    this.$emit('onClearSelected')
  }

  public imageCoverId: any = {
    id: null,
    link: defaultImage,
  }
  public imageThumbnailId: any = {
    id: null,
    link: defaultImage,
  }
  public imageLogoId: any = {
    id: null,
    link: defaultImage,
  }

  public changeImageCoverId(item) {
    this.stateCoverImage = false
    this.imageCoverId.id = item.id
    this.imageCoverId.link = item.link
  }
  public changeImageThumbnailId(item) {
    this.stateThumbnailImage = false
    this.imageThumbnailId.id = item.id
    this.imageThumbnailId.link = item.link
  }
  public changeImageLogoId(item) {
    this.stateLogoImage = false
    this.imageLogoId.id = item.id
    this.imageLogoId.link = item.link
  }

  public stateCoverImage = false
  public stateThumbnailImage = false
  public stateLogoImage = false
  public stateCarType = false
  public stateStatus = false
  public postData() {
    this.$v.name.$touch()
    if (
      this.$v.name.$invalid ||
      this.imageCoverId.id === null ||
      this.imageThumbnailId.id === null ||
      this.imageLogoId.id === null
    ) {
      this.imageCoverId.id === null
        ? (this.stateCoverImage = true)
        : (this.stateCoverImage = false)
      this.imageThumbnailId.id === null
        ? (this.stateThumbnailImage = true)
        : (this.stateThumbnailImage = false)
      this.imageLogoId.id === null
        ? (this.stateLogoImage = true)
        : (this.stateLogoImage = false)
      this.stateCarType = true
      this.stateStatus = true
    } else {
      const dataToPost = {
        name: this.name,
        isActive: this.status,
        imageCoverId: this.imageCoverId.id,
        imageThumbnailId: this.imageThumbnailId.id,
        imageLogoId: this.imageLogoId.id,
        tag: this.carType,
      }
      TrainingCategoryDataModule.postTrainingCategory(dataToPost)
      this.$root.$emit('bv::hide::modal', this.idModal)
    }
  }
}
